import { module } from "angular";
import { ExtendedSearchOverviewComponent } from "./ExtendedSearchOverviewComponent";

module("mmGui").component("irExtendedSearchOverview", new ExtendedSearchOverviewComponent());
